/* eslint-disable react/prop-types */
import React from 'react';
import { Wind } from 'lucide-react';

/**
 * Recovery Window Awareness™ — calm observation only.
 *
 * No score, no tier, no alarm. Just a soft note about the rhythm of deep
 * conversations vs. reflection gaps in the window.
 */
export default function RecoveryWindowAwareness({ awareness, compact = false }) {
  if (!awareness) return null;
  return (
    <section data-testid="recovery-window-awareness"
              className="rounded-xl border border-[#E5D6BE] bg-[#FAF1E1]/30 p-3 space-y-1.5">
      <header className="flex items-center gap-1">
        <Wind className="w-3 h-3 text-[#8C6239]" />
        <p className="text-[10px] uppercase tracking-[0.16em] text-[#8C6239]">
          Recovery Window Awareness™
        </p>
      </header>
      <ul className="space-y-1">
        {(awareness.notes || []).map((n, i) => (
          <li key={i} data-testid={`awareness-note-${i}`}
              className="text-[12px] text-[#5C3D1F] leading-relaxed">
            {n}
          </li>
        ))}
      </ul>
      {!compact && (
        <p className="text-[10px] text-[#8A8681] tabular-nums">
          {awareness.deep_log_count} deep convos ·
          {' '}{awareness.deep_cluster_tightness_pct}% clustered ·
          {' '}{awareness.longest_reflection_gap_hours}h longest reflection gap
        </p>
      )}
    </section>
  );
}
